import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'sonner';
import { ColorDeMarca } from '@/components/layout/ColorDeMarca';
import { router } from '@/app/router';
import { queryClient } from '@/lib/queryClient';
import '@/styles/globals.css';

// React Query devtools disabled everywhere. Flip to `import.meta.env.DEV`
// if you want the tropical-island toggle back during local debugging.
const SHOW_DEVTOOLS = false;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Aplica el color de marca de la empresa a todo el sistema. Va aquí
          arriba para que cubra también el portal del cliente y el login. */}
      <ColorDeMarca />
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors closeButton />
      {SHOW_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>,
);
